import axios from "axios";
import { toast } from "sonner";

export const BILLING_URL = "https://ai.studio/projects";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
if (!configuredBackendUrl && process.env.NODE_ENV === "production") {
  throw new Error("REACT_APP_BACKEND_URL is required for production builds");
}
const backendUrl = (configuredBackendUrl || "http://localhost:8001").replace(/\/$/, "");
export const API = `${backendUrl}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Error "kredit habis" bisa muncul dari jalur mana saja: generate image,
// baca produk dari foto, sampai minta saran AI. Menanganinya di interceptor
// membuat setiap halaman otomatis punya jalan keluar tanpa menulis ulang
// blok catch di puluhan tempat.
const billingNotifiedAt = { current: 0 };

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const code = error?.response?.data?.detail?.code;
    if (code === "billing") {
      // Job poller bisa gagal berulang kali; beri tahu sekali saja supaya
      // tidak menumpuk toast identical di layar.
      const now = Date.now();
      if (now - billingNotifiedAt.current > 15000) {
        billingNotifiedAt.current = now;
        toast.error("Saldo kredit Google habis", {
          description:
            "Generate berhenti di tengah. Top up di AI Studio pada project kamu, lalu ulangi.",
          duration: 15000,
          action: {
            label: "Top up",
            onClick: () => window.open(BILLING_URL, "_blank", "noopener,noreferrer"),
          },
        });
      }
    }
    return Promise.reject(error);
  },
);

export function fileUrl(path) {
  if (!path) return "";
  return `${API}/files/${path}`;
}
